<template>
  <div class="profile-summary">
    <v-layout row>
      <v-flex lg3>
        <div class="identifier-container sf-rockwell-condensed">
          <v-layout row>
            <v-flex lg7>
              <h3 id="loanNo" :class="getLoanNoClass()" class="loan-no">
                {{ tool.fieldRender(loan, '{loanNo}') }}
              </h3>
            </v-flex>
            <v-flex lg5>
              <v-layout row>
                <v-flex lg12>
                  <v-tooltip bottom v-if="isShowElement(privileges, dataType.PrivilegeCode.COPY_LOAN, dataType.PrivilegeType.EXECUTABLE)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="primary" class="action-button" @click="copyLoanNo" slot="activator"
                             v-bind="attrs"
                             v-on="on">
                        <i class="fas fa-copy"></i>
                      </v-btn>
                    </template>
                    <span>Copy App #</span>
                  </v-tooltip>
                  <v-tooltip bottom max-width="800px" v-if="isShowElement(privileges, dataType.PrivilegeCode.SHOW_LEAD_PROVIDER, dataType.PrivilegeType.EXECUTABLE)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small slot="activator" color="orange" class="action-button" v-bind="attrs" v-on="on">
                        <i class="fas fa-bookmark"></i>
                      </v-btn>
                    </template>
                    <span>Lead provider : {{ leadProviderName }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="isShowElement(privileges, dataType.PrivilegeCode.LOCK_LOAN, dataType.PrivilegeType.EXECUTABLE)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon
                             small
                             slot="activator"
                             :color="currentLockedId === -1 ? 'primary' : currentLockedId === operatorId ? 'green' : 'red'"
                             class="action-button"
                             @click="toLockOrUnLockApp"
                             v-bind="attrs"
                             v-on="on"
                      >
                        <i class="fas" :class="currentLockedId !== -1 ? 'fa-lock' : 'fa-lock-open'"></i>
                      </v-btn>
                    </template>
                    <span>{{
                  currentLockedId === -1
                    ? 'Lock'
                    : `Locked by ${currentLockedBy.firstName}`
                }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex lg12>
                  <v-tooltip bottom v-if="sameDayIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        slot="activator"
                        class="action-button"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                      </v-btn>
                    </template>
                    <span>Same Day</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="returningIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="28px"
                      >
                        <span class="material-icons" :style="returningIcon.color">{{ returningIcon.style }}</span>
                      </v-btn>
                    </template>
                    <span>{{ returningIcon.title }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="creditCardIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                      </v-btn>
                    </template>
                    <span>Credit Card</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="compressIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                      </v-btn>
                    </template>
                    <span>compress</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="foxExpressIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: red !important;">support</span>
                      </v-btn>
                    </template>
                    <span>Fox Express</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <div class="flag-container sf-agency-fb">
          <template v-for="(flag, index) in ApplicationFlags">
            <v-tooltip
              bottom
              :key="index"
              v-if="showFlagsDescription(flag.value)"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  class="flag"
                  label
                  x-small
                  outlined
                  :color="flag.class"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ flag.text }}
                </v-chip>
              </template>
              <span>{{ flag.tooltip }}</span>
            </v-tooltip>
          </template>
          <template v-if="loan.category == dataType.CategoryEnum.JARVIS.value">
            <v-chip
              class="flag"
              label
              x-small
              outlined
              color="orange darken-2"
            >
              T
            </v-chip>
          </template>
          <v-chip
            class="flag"
            label
            x-small
            outlined
            v-if="fileBatchNo"
            color="orange darken-2"
            >
            Batch Number: {{ fileBatchNo }}
          </v-chip>
        </div>
      </v-flex>
      <v-flex lg9>
        <div class="data-form">
          <v-layout row wrap>
            <v-flex lg2>
              <label class="field-name">Requested Amount</label>
            </v-flex>
            <v-flex lg2>
              <label class="field-value" :title="tool.fieldRender(loan, '{requestedAmount}', 'currency')">
                {{ tool.fieldRender(loan, '{requestedAmount}', 'currency') }}
              </label>
            </v-flex>
            <v-flex lg2>
              <label class="field-name">Current Status</label>
            </v-flex>
            <v-flex lg2>
              <label class="field-value" :title="tool.fieldRender(this.loan, '{loanStatusText}')">
                {{ tool.fieldRender(this.loan, '{loanStatusText}') }}
              </label>
            </v-flex>
            <v-flex lg2>
              <label class="field-name">IBV Status</label>
            </v-flex>
            <v-flex lg2>
              <label class="field-value" :title="tool.fieldRender(loan, '{ibvStatus}', null, { ibvStatus: dataType.IbvStatus })">
                {{ tool.getEnumTextByValue(dataType.IbvStatus, ibvStatus) || 'N/A' }}
              </label>
            </v-flex>
            <template v-if="isShowElement(privileges, dataType.PrivilegeCode.CUSTOMER_TYPE, dataType.PrivilegeType.READABLE)">
              <v-flex lg2>
                <label class="field-name">Customer Type</label>
              </v-flex>
              <v-flex lg2>
                <label class="field-value" :title="tool.fieldRender(loan, '{category}', null, { category: dataType.Category })">
                  {{ tool.fieldRender(loan, '{category}', null, { category: dataType.Category }) }}
                </label>
              </v-flex>
            </template>
            <v-flex lg2>
              <label class="field-name">Past Status</label>
            </v-flex>
            <v-flex lg2>
              <label class="field-value" :title="tool.fieldRender(loan, '{pastStatusText}')">
                {{ tool.fieldRender(loan, '{pastStatusText}') }}
              </label>
            </v-flex>
            <v-flex lg2>
              <label class="field-name">E-Sign Status</label>
            </v-flex>
            <v-flex lg2>
              <label class="field-value" :title="tool.fieldRender(loan, '{signStatus}', null, { signStatus: dataType.SignStatus })">
                {{ tool.fieldRender(loan, '{signStatus}', null, { signStatus: dataType.SignStatus }) }}
                <v-tooltip bottom v-if="(loan.signStatus === dataType.SignStatusEnum.NOT_SIGNED.value || loan.signStatus === dataType.SignStatusEnum.IN_PROGRESS.value || loan.signStatus === dataType.SignStatusEnum.VOID_IN_PROGRESS.value || loan.signStatus === dataType.SignStatusEnum.RECOVER_IN_PROGRESS.value) && isShowElement(privileges, dataType.PrivilegeCode.REFRESH_ESIGN_STATUS, dataType.PrivilegeType.EXECUTABLE)">
                  <template v-slot:activator="{ on, attrs }">
                    <i icon class="fad fa-sync-alt" @click="refreshSignStatus" slot="activator"
                       v-bind="attrs"
                       v-on="on">
                    </i>
                  </template>
                  <span>Refresh E-Sign Status</span>
                </v-tooltip>
              </label>
            </v-flex>
            <template v-if="isShowElement(privileges, dataType.PrivilegeCode.SOURCE, dataType.PrivilegeType.READABLE)">
              <v-flex lg2>
                <label class="field-name">Source</label>
              </v-flex>
              <v-flex lg2>
                <label class="field-value" :title="getSourceData(loan)">
                  {{ getSourceData(loan) }}
                </label>
              </v-flex>
            </template>
            <template v-if="isShowElement(privileges, dataType.PrivilegeCode.EDIT_WAGE_ASSIGNMENT, dataType.PrivilegeType.READABLE) && isShowWageAssignment(loan.portfolioId, collectionProvider)">
              <v-flex lg2>
                <label class="field-name">
                  {{ getWageAssignment(collectionProvider) }}
                  <v-btn
                    icon
                    :disabled="!(isShowElement(privileges, dataType.PrivilegeCode.EDIT_WAGE_ASSIGNMENT, dataType.PrivilegeType.EXECUTABLE) && checkWhetherUpdateWageAssignment() && isLockByCurrentUser())"
                    color="blue"
                    @click="updateWageAssignment"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </label>
              </v-flex>
            </template>
            <template v-if="loan.loanStatus === dataType.LoanStatus.UNDERWRITER_REVIEW.value && isShowAudited(restricts, loan.loanStatus)">
              <v-flex lg2>
                <label class="field-name">Audited By</label>
              </v-flex>
              <v-flex lg2>
                <label class="field-value" :title="tool.isEmpty(auditedBy) ? 'N/A': auditedBy">
                  {{ tool.isEmpty(auditedBy) ? 'N/A': auditedBy }}
                </label>
              </v-flex>
            </template>
            <template v-if="loan.loanStatus === dataType.LoanStatus.UNDERWRITER_REVIEW.value && isDisplayProcessedVia">
              <v-flex lg2>
                <label class="field-name">Processed Via</label>
              </v-flex>
              <v-flex lg2>
                <label class="field-value" title="Remote Consent or RPC">
                  Remote Consent or RPC
                </label>
              </v-flex>
            </template>
            <template v-if="loan.loanStatus === dataType.LoanStatus.AGENT_REVIEW.value && isShowIbvSentBy">
              <v-flex lg2>
                <label class="field-name">IBV Sent By</label>
              </v-flex>
              <v-flex lg2>
                <label class="field-value" :title="tool.isEmpty(ibvSentBy) ? 'N/A': ibvSentBy">
                  {{ tool.isEmpty(ibvSentBy) ? 'N/A': ibvSentBy }}
                </label>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="grabData.snackbar"
      :timeout="grabData.timeout"
      :right=true
      :top=true
    >
      <div class="snackbar">
        <div>
          <v-toolbar-title class="body-2">
            <span class="headline snackbar-title">Grab Request</span>
          </v-toolbar-title>
          <span class="snackbar-text">
          {{ grabData.display }}
        </span>
        </div>
        <div style="width: 100%">
          <v-btn
            class="snackbar-button"
            color="blue"
            text
            @click="grabAction(dataType.LoanActionEnum.GRAB_REJECT.value)"
          >
            Reject
          </v-btn>
          <v-btn
            class="snackbar-button"
            color="blue"
            text
            @click="grabAction(dataType.LoanActionEnum.GRAB_ACCEPT.value)"
          >
            {{ grabData.acceptText }}
          </v-btn>
        </div>
      </div>
    </v-snackbar>
<!--    returning customer dialog-->
    <v-dialog
      v-model="returningDialog.show"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Returning Client
        </v-card-title>
        <v-card-text>
          This app# {{ loan.loanNo }} is a returning customer
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="returningDialog.show = false"
            :disabled="returningDialog.showBtn"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<!--    follow up dialog-->
    <v-dialog
      v-model="followUpDialog.show"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Follow Up Tips
        </v-card-title>
        <v-card-text>
          Lead with follow up expiring at {{ followUpDialog.followUpInfo }} EST
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="followUpDialog.show = false"
            v-if="followUpDialog.showBtn"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { OriginationBusinessApi, OriginationApi, LoanOperationApi, LoanResourceApi, PaymentApi } from '@/api/pandaria'
import { Authentication, DataType, Tool, Popup } from '@/util/index'
import { _ } from 'vue-underscore'
import BgTile from '@/assets/images/bg-tile-opacity-20.png'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'application-detail-profile-summary',
  props: {
    loan: Object,
    slaveLoanId: Number,
    collectionProvider: Number,
    operator: Object,
    privileges: {
      type: Array,
      default: () => []
    },
    restricts: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      ibvStatus: '',
      ApplicationFlags: [
        { value: 1 << 1, text: 'Imported', class: 'blue darken-2', tooltip: 'Imported' },
        { value: 1 << 2, text: 'Expressed', class: 'orange darken-2', tooltip: 'Expressed' },
        { value: 1 << 3, text: 'Transferred', class: 'red darken-2', tooltip: 'Transferred' },
        { value: 1 << 4, text: 'Auto', class: 'green darken-2', tooltip: 'Auto' },
        { value: 1 << 7, text: 'Do not lend', class: 'red darken-2', tooltip: 'Do not lend' },
        { value: 1 << 18, text: 'PM', class: 'blue darken-2', tooltip: 'Pigeon Marketing' }
      ],
      isDisable: false,
      dataType: DataType,
      tool: new Tool(),
      currentLockedId: -1,
      currentLockedBy: {},
      auditedBy: 'N/A',
      grabData: {
        snackbar: false,
        timeout: 20000,
        text: 'There is the agent <%= data.employeeId %> <%= data.fullName %> is requesting to grab the loan <%= data.loanNo %> which is locked by you now',
        display: null,
        time: 20,
        acceptText: 'Accept(20S)'
      },
      grabMessage: {},
      timer: null,
      leadProviderName: '',
      returningIcon: {
        style: null,
        color: null,
        title: null,
        display: false
      },
      sameDayIcon: {
        display: false
      },
      creditCardIcon: {
        display: false
      },
      compressIcon: {
        display: false
      },
      foxExpressIcon: {
        display: false
      },
      isDisplayProcessedVia: false,
      ibvSentBy: null,
      isShowIbvSentBy: false,
      returningDialog: {
        show: false,
        showBtn: true,
        timer: null
      },
      followUpDialog: {
        show: false,
        showBtn: true,
        followUpInfo: ''
      },
      fileBatchNo: '',
      searchKey: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    },
    operatorId () {
      return this.operator.id
    },
    lockedId () {
      return this.loan.lockedId
    }
  },
  watch: {
    'store.getters.getPPSCurrentAppId': {
      handler: function (val) {
        this.getCollectionData(val)
      }
    },
    loanId (val) {
      const $this = this
      this.showIbvSentBy(this.loan)
      const request = {
        loanId: val,
        feature: 'LOCK'
      }
      OriginationApi.getLoanByIdAndFeature(request, function (result) {
        if ($this.tool.isNotEmpty(result.lockedBy)) {
          const lockedInfo = JSON.parse(result.lockedBy)
          Object.assign($this.currentLockedBy, lockedInfo)
          $this.currentLockedId = lockedInfo.id
        }
        if (DataType.LockLoanReasonEnum.GENERATE_LOAN.value === $this.$store.getters.getLockReason) {
          $this.$eventBus.$emit('resetFollowUp')
        }
        if ($this.tool.isEmpty(result.lockedId)) {
          $this.doLockLoan(true)
        } else {
          $this.$eventBus.$emit('broadcastLockedId', result.lockedId)
        }
        $this.$forceUpdate()
      })

      OriginationApi.getLoanPastStatusByLoanId(
        $this.loanId,
        function (resultData) {
          $this.loan.pastStatusText = resultData
          $this.$forceUpdate()
        }
      )

      if ($this.tool.isNotEmpty($this.loan.loanType) && $this.loan.loanType !== DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        $this.getCollectionData(val)
      }

      LoanResourceApi.getLeadProviderByLoanId({ leadProviderId: $this.loan.leadProviderId }, function (result) {
        if ($this.tool.isNotEmpty(result)) {
          $this.leadProviderName = result.abbrName
        }
      })

      this.uploadIcon(this.loan)

      this.showReturningCustomerDialog(this.loan)

      this.showFollowUpDialog()

      if (this.loan.loanStatus === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
        const request = {
          loanId: this.loanId,
          feature: 'REMOTE_CONSENT'
        }
        OriginationApi.getSectionFeature(request, function (result) {
          if ($this.tool.isNotEmpty(result) && result.flags === 1) {
            $this.isDisplayProcessedVia = true
          }
        })
      }
    },
    'loan.loanStatus': function (val) {
      const $this = this
      OriginationApi.getLoanOperationByLoanId(
        $this.loanId,
        function (resultData) {
          $this.$store.commit('setLoanOperation', resultData)
          if (val === DataType.LoanStatus.UNDERWRITER_REVIEW.value) {
            $this.auditedBy = $this.tool.getFullName(resultData.auditedBy)
          }
        }
      )
    },
    loan: {
      handler: function (val) {
        if (this.tool.isNotEmpty(val) && this.tool.isNotEmpty(val.FoxFlag)) {
          if (DataType.LoanActionEnum.UPDATE_LOAN_FLAGS_FOX_V4.value === val.FoxFlag) {
            this.foxExpressIcon.display = false
          }
        }
        if (tool.isNotEmpty(val) && tool.isNotEmpty(val.ibvDataList)) {
          const ibvData = {}
          val.ibvDataList.map(item => {
            if (item.provider === DataType.IBVProviderType.DECISION_LOGIC.value) {
              ibvData.DLData = item
            } else if (item.provider === DataType.IBVProviderType.CHIRP.value) {
              ibvData.chirpData = item
            }
          })

          if (tool.isNotEmpty(ibvData)) {
            if (tool.isEmpty(ibvData.chirpData) && tool.isNotEmpty(ibvData.DLData)) {
              this.ibvStatus = ibvData.DLData.ibvStatus
            } else if (tool.isEmpty(ibvData.DLData) && tool.isNotEmpty(ibvData.chirpData)) {
              this.ibvStatus = ibvData.chirpData.ibvStatus
            } else if (tool.isNotEmpty(ibvData.chirpData) && tool.isNotEmpty(ibvData.DLData)) {
              if (ibvData.DLData.ibvStatus === 3) {
                this.ibvStatus = ibvData.DLData.ibvStatus
              } else if (ibvData.chirpData.ibvStatus === 3) {
                this.ibvStatus = ibvData.chirpData.ibvStatus
              } else {
                this.ibvStatus = ibvData.DLData.ibvStatus
              }
            }
          } else {
            this.ibvStatus = null
          }
        } else {
          this.ibvStatus = null
        }
      },
      immediate: true,
      deep: true
    }
  },
  destroyed () {
    this.$eventBus.$off('forceUnlock')
    this.$eventBus.$off('updateProfileSectionSignStatus')
    this.$eventBus.$off('grabLockRequest')
    this.$eventBus.$off('grabLockAccept')
    this.$eventBus.$off('grabLockReject')
    this.$eventBus.$off('judgeSameDayEvent')
    this.$eventBus.$off('updateIbvStatus')
    this.$eventBus.$off('handle')
    this.$eventBus.$off('judgeCreditCardEvent')
    this.$eventBus.$off('judgeCompressEvent')
    this.$eventBus.$off('resolutionUnlock')
    this.$eventBus.$off('updateCurrentLockedId')
    this.$eventBus.$off('createIbvStatus')
  },
  mounted () {
    this.$eventBus.$on('createIbvStatus', target => {
      if (tool.isNotEmpty(target)) {
        this.ibvStatus = target
      }
    })
    this.searchKey = window.localStorage.getItem('searchKey')
    this.$eventBus.$on('forceUnlock', target => {
      const $this = this
      LoanOperationApi.unlockLoan({ loanId: this.loanId, unlockReason: target.unlockReason }, function () {
        $this.currentLockedId = -1
        $this.currentLockedBy = {}
        $this.$eventBus.$emit('broadcastLockedId', -1)
      })
    })
    this.$eventBus.$on('updateProfileSectionSignStatus', target => {
      this.loan.signStatus = target
      this.$forceUpdate()
    })
    this.$eventBus.$on('grabLockRequest', target => {
      const message = JSON.parse(target.message)
      this.grabMessage = message
      this.uploadGrabText(message)
      this.grabData.snackbar = true
      if (this.grabData.time === 20) {
        this.timer = setInterval(() => this.timeDown(), 1000)
      }
    })
    this.$eventBus.$on('grabLockAccept', target => {
      this.currentLockedId = this.operatorId
      this.currentLockedBy = this.operator
      this.$eventBus.$emit('broadcastLockedId', this.operatorId)
      popup.popupForSuccess('Grab Successfully.')
      this.$forceUpdate()
    })
    this.$eventBus.$on('grabLockReject', target => {
      popup.popupForInfo('Grab Reject.')
    })
    this.$eventBus.$on('get-loan-detail-event', target => {
      this.loan.loanStatusText = DataType.LoanStatus.MANUALLY_VOIDED.text
    })
    this.$eventBus.$on('get-installment-status-event', target => {
      const $this = this
      const request = {
        loanId: $this.loanId,
        feature: 'STATUS'
      }
      OriginationApi.getLoanByIdAndFeature(request, function (result) {
        $this.loan.loanStatus = result.loanStatus
        $this.loan.loanStatusText = result.loanStatusText
      })
    })
    this.$eventBus.$on('judgeSameDayEvent', target => {
      const $this = this
      const request = {
        loanId: $this.loanId
      }
      OriginationBusinessApi.judgeSameDayLoan(request, function (result) {
        $this.sameDayIcon.display = result
      })
    })
    this.$eventBus.$on('judgeCreditCardEvent', target => {
      const $this = this
      $this.creditCardIcon.display = target
    })
    this.$eventBus.$on('judgeCompressEvent', target => {
      const $this = this
      $this.compressIcon.display = target
    })
    this.$eventBus.$on('updateIbvStatus', target => {
      if (this.tool.isEmpty(this.ibvSentBy)) {
        this.isShowIbvSentBy = true
        this.ibvSentBy = this.tool.getFullName(this.store.getters.getAccount)
      }
    })
    this.$eventBus.$on('handle', target => {
      const $this = this
      if ($this.tool.isNotEmpty(target)) {
        if (target.loanId === $this.loan.id) {
          popup.popupForWarning('Loan is Handled by Resolutions Department - DO NOT TOUCH.')
          this.currentLockedId = -1
          this.currentLockedBy = {}
          this.$eventBus.$emit('broadcastLockedId', -1)
          this.$forceUpdate()
        }
      }
    })
    this.$eventBus.$on('resolutionUnlock', target => {
      if (this.operatorId !== this.currentLockedId) {
        this.currentLockedId = -1
        this.currentLockedBy = {}
      }
    })
    this.$eventBus.$on('updateCurrentLockedId', target => {
      this.currentLockedId = -1
      this.currentLockedBy = {}
      this.$eventBus.$emit('broadcastLockedId', -1)
      const $this = this
      const roleCode = $this.store.getters.getRoleCode
      popup.popupForWarning('You have locked other loan.', null, function () {
        if (roleCode === DataType.RoleEnum.ORIGINATION_AGENT.code || roleCode === DataType.RoleEnum.ORIGINATION_AGENT_OUTBOUND.code) {
          $this.$router.push({ path: '/welcome' })
        }
      })
      this.$forceUpdate()
    })
  },
  methods: {
    getLoanNoClass () {
      if (tool.isNotEmpty(this.loan) && tool.isNotEmpty(this.loan.flags)) {
        let JarvisFlag = null
        if (tool.isNotEmpty(this.loan.tags)) {
          JarvisFlag = (DataType.LoanFlagsEnum.JARVIS.value & this.loan.flags) === DataType.LoanFlagsEnum.JARVIS.value
        }
        const FoxFlag = (DataType.LoanFlagsEnum.FOX_EXPRESS.value & this.loan.flags) === DataType.LoanFlagsEnum.FOX_EXPRESS.value
        const detailSummary = this.$parent.$parent.$refs.detailSummary
        if (detailSummary !== undefined) {
          if (JarvisFlag || FoxFlag) {
            detailSummary.$el.style.setProperty('background-image', 'url("' + BgTile + '")')
            detailSummary.$el.style.setProperty('background-repeat', 'repeat-x')
          } else {
            detailSummary.$el.style.removeProperty('background-image')
            detailSummary.$el.style.removeProperty('background-repeat')
          }
        }

        return JarvisFlag || FoxFlag ? 'loan-no-text' : ''
      }
    },
    getCollectionData (loanId) {
      const $this = this
      if (tool.isEmpty(loanId)) {
        $this.fileBatchNo = ''
        return
      }
      if (this.$route.path.includes(DataType.RouterPath.LCS_PATH)) {
        PaymentApi.getCollectionData({ loanId: loanId }, function (result) {
          if (tool.isNotEmpty(result?.fileBatchNo)) {
            $this.fileBatchNo = result.fileBatchNo
          }
        }, function () {
          $this.fileBatchNo = ''
        })
      } else {
        $this.fileBatchNo = ''
      }
    },
    showFlagsDescription (targetFlag) {
      const flagScope = this.loan.flags & targetFlag
      if (flagScope === DataType.LoanFlagsEnum.DO_NOT_LEND.value &&
        !Authentication.matchRestricts(this.restricts, DataType.LoanStatus.UNDERWRITER_REVIEW.value)) {
        return false
      }
      return flagScope === targetFlag
    },
    showIbvSentBy (data) {
      if (tool.isNotEmpty(data.ibvDataList)) {
        const ibvDataObj = {}
        data.ibvDataList.map(item => {
          if (item.provider === DataType.IBVProviderType.DECISION_LOGIC.value) {
            ibvDataObj.DLData = item
          } else if (item.provider === DataType.IBVProviderType.CHIRP.value) {
            ibvDataObj.chirpData = item
          }
        })
        if (tool.isNotEmpty(ibvDataObj)) {
          if (tool.isEmpty(ibvDataObj.chirpData) && tool.isNotEmpty(ibvDataObj.DLData)) {
            this.getIBVSentBy(ibvDataObj.DLData)
          } else if (tool.isEmpty(ibvDataObj.DLData) && tool.isNotEmpty(ibvDataObj.chirpData)) {
            this.getIBVSentBy(ibvDataObj.chirpData)
          } else if (tool.isNotEmpty(ibvDataObj.chirpData) && tool.isNotEmpty(ibvDataObj.DLData)) {
            if (ibvDataObj.DLData.providerStatus === 1) {
              this.getIBVSentBy(ibvDataObj.DLData)
            } else if (ibvDataObj.chirpData.providerStatus === 1) {
              this.getIBVSentBy(ibvDataObj.chirpData)
            } else {
              this.getIBVSentBy(ibvDataObj.DLData)
            }
          }
        }
      }
    },
    getIBVSentBy (item) {
      if (this.tool.isNotEmpty(item.ibvStatus) && item.ibvStatus === '3' && this.tool.isNotEmpty(item.createdId)) {
        this.isShowIbvSentBy = true
        if (item.createdId === -2) {
          this.ibvSentBy = 'Customer Action'
        } else if (this.tool.isNotEmpty(item.createdBy)) {
          this.ibvSentBy = this.tool.getFullName(JSON.parse(item.createdBy))
        }
      }
    },
    getWageAssignment (collectionProvider) {
      const enumByValue = tool.getEnumByValue(DataType.CollectionProviderEnum, collectionProvider)
      if (tool.isEmpty(enumByValue)) {
        return 'N/A'
      }
      return enumByValue.text
    },
    getSourceData (loan) {
      let result = this.tool.getEnumTextByValue(this.dataType.LoanSourceEnum, loan.source)
      if (this.tool.isNotEmpty(result) && loan.flags === 1 && loan.priority === 931) {
        result += '(Rocket)'
      }
      return result
    },
    refreshSignStatus () {
      const $this = this
      const data = {}
      data.loanId = $this.loan.id
      data.loanNo = $this.loan.loanNo
      OriginationBusinessApi.getSignStatusFromEsw(data, function (resultData) {
        const signatureStatus = resultData[DataType.JsonKeyConst.DOCUMENT_STATUS]
        $this.loan.signStatus = signatureStatus
        if (signatureStatus === DataType.SignStatusEnum.SIGNED.value) {
          $this.loan.contractUrl = resultData.documentUrl
          $this.loan.certificateUrl = resultData.certificateUrl
          $this.loan.signedAt = resultData.documentSignatureTime
        }
        $this.$forceUpdate()
        const loanData = $this.loan
        $this.store.commit('setLoan', { loan: $this.loan })
        $this.$eventBus.$emit('loanSignDataDisplay', { loanData })
      }, function (error) {
        popup.popupForWarning(error.message)
      })
    },
    copyLoanNo () {
      const copyText = document.getElementById('loanNo').innerText
      const oInput = document.createElement('input')
      oInput.value = copyText
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('copy')
      oInput.className = 'oInput'
      oInput.style.display = 'none'
      window._VMA.$emit('SHOW_SNACKBAR', {
        text: 'Copy Successfully.',
        color: 'success'
      })
    },
    doLockLoan (isAuto) {
      const $this = this
      const lockReason = this.$store.getters.getLockReason
      const request = {
        loanId: this.loanId,
        lockReason: DataType.LockLoanReasonEnum.AUTOMATIC_LOCK.value
      }
      if (tool.isNotEmpty(this.searchKey)) {
        request.searchKey = this.searchKey
      }
      if (this.tool.isNotEmpty(lockReason)) {
        request.lockReason = lockReason
        this.$store.commit('setLockReason', '')
      }
      LoanOperationApi.lockLoan(
        request,
        function () {
          $this.currentLockedId = $this.operatorId
          $this.currentLockedBy = $this.operator
          $this.$eventBus.$emit('broadcastLockedId', $this.operatorId)
          $this.$eventBus.$emit('reLockLoan', $this.operatorId)
          $this.$forceUpdate()
          window.localStorage.removeItem('searchKey')
        },
        function (result) {
          if ($this.tool.isEmpty(isAuto) || !isAuto) {
            popup.popupForWarning(result.message)
          }
        }
      )
    },
    toLockOrUnLockApp () {
      const $this = this
      const isLocked = ($this.currentLockedId !== -1)
      const isOwnerLocked = ($this.operatorId === this.currentLockedId)
      if (isLocked && isOwnerLocked) {
        LoanOperationApi.unlockLoan({ loanId: $this.loanId, unlockReason: DataType.UnlockLoanReasonEnum.MANUAL_UNLOCK.value }, function () {
          $this.currentLockedId = -1
          $this.currentLockedBy = {}
          $this.$eventBus.$emit('broadcastLockedId', -1)
          $this.$forceUpdate()
        })
      } else if (isLocked && !isOwnerLocked) {
        if (this.isShowElement(this.privileges, DataType.PrivilegeCode.GRAB_LOAN, DataType.PrivilegeType.EXECUTABLE)) {
          popup.popupForWarning('Are you sure to grab lock on this loan?', { showCancelButton: true }, function () {
            $this.grabAction(DataType.LoanActionEnum.GRAB_REQUEST.value)
          })
        }
      } else {
        $this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.MANUAL_LOCK.value)
        this.doLockLoan()
      }
    },
    uploadGrabText (message) {
      const data = {
        employeeId: message.initiatorInfo.initiatorId,
        fullName: this.tool.getFullName(message.initiatorInfo),
        loanNo: this.loan.loanNo
      }
      this.grabData.display = _.template(JSON.stringify(this.grabData.text))({ data: data }).replace(/"/g, '')
    },
    timeDown () {
      if (this.grabData.time - 1 < 0) {
        clearInterval(this.timer)
        this.grabData.time = 20
        this.grabData.acceptText = 'Accept(20S)'
        this.grabAction(DataType.LoanActionEnum.GRAB_ACCEPT.value)
      } else {
        this.grabData.acceptText = 'Accept(' + (this.grabData.time - 1) + 's)'
        this.grabData.time = this.grabData.time - 1
      }
    },
    grabAction (action) {
      const $this = this
      let grabRequest = {}
      switch (action) {
        case DataType.LoanActionEnum.GRAB_REQUEST.value:
          grabRequest = {
            loanId: this.loanId,
            action: DataType.LoanActionEnum.GRAB_REQUEST.value,
            processorId: this.currentLockedId,
            processorOpenId: this.currentLockedBy.openId
          }
          break
        case DataType.LoanActionEnum.GRAB_ACCEPT.value:
        case DataType.LoanActionEnum.GRAB_REJECT.value:
          grabRequest = {
            loanId: this.loanId,
            action: action,
            initiatorId: this.grabMessage.initiatorInfo.initiatorId,
            initiatorOpenId: this.grabMessage.initiatorInfo.initiatorOpenId,
            initiatorToken: this.grabMessage.initiatorToken
          }
          clearInterval(this.timer)
          this.grabData.time = 20
          this.grabData.acceptText = 'Accept(20S)'
          this.grabData.snackbar = false
          break
        default:
          popup.popupForWarning('Please refresh page and try again.')
      }
      LoanOperationApi.grabLockedLoan(
        grabRequest,
        function () {
          if (DataType.LoanActionEnum.GRAB_ACCEPT.value === action) {
            $this.currentLockedId = $this.grabMessage.initiatorInfo.initiatorId
            $this.grabMessage.initiatorInfo.openId = $this.grabMessage.initiatorInfo.initiatorOpenId
            $this.currentLockedBy = $this.grabMessage.initiatorInfo
            $this.$eventBus.$emit('broadcastLockedId', -1)
          }
        },
        function (result) {
          popup.popupForWarning(result.message)
        }
      )
    },
    checkWhetherUpdateWageAssignment () {
      const loanId = this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value ? this.slaveLoanId : this.loan.id
      if (tool.isEmpty(loanId)) {
        return this.isDisable
      }
      const input = { loanId: loanId }
      const $this = this
      PaymentApi.checkWhetherUpdateWageAssignment(input, function (result) {
        $this.isDisable = result === 1
      }, function () {
        $this.isDisable = false
      })
      return this.isDisable
    },
    updateWageAssignment () {
      const loanId = this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value ? this.slaveLoanId : this.loan.id
      const targetCollectionProvider = DataType.CollectionProviderEnum.WAGE_ASSIGNMENT.value
      const input = {
        loanId: loanId,
        collectionProvider: targetCollectionProvider
      }
      const $this = this
      popup.popupForWarning('Are you sure change the wageAssignment type?', { showCancelButton: true }, function () {
        PaymentApi.updateWageAssignment(input, function () {
          $this.$route.path.includes('/collection/application/') ? location.reload() : $this.$router.push({ path: '/collection/application/' + $this.$route.params.uuid })
        }, function (result) {
          popup.popupForError(result.message)
          $this.$route.path.includes('/collection/application/') ? location.reload() : $this.$router.push({ path: '/collection/application/' + $this.$route.params.uuid })
        })
      })
    },
    isShowWageAssignment (portfolioId, collectionProvider) {
      return collectionProvider !== undefined && collectionProvider !== -1
    },
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    },
    isShowAudited (restricts, loanStatus) {
      return Authentication.matchRestricts(restricts, loanStatus)
    },
    isLockByCurrentUser () {
      return Authentication.isLockedByCurrentUser(this.store.getters.getAccount, this.currentLockedId)
    },
    uploadIcon (loanData) {
      if (this.tool.isNotEmpty(loanData)) {
        const flags = loanData.flags
        const tags = loanData.tags
        if (DataType.LoanFlagsEnum.INSTANT_FUND.value === (flags & DataType.LoanFlagsEnum.INSTANT_FUND.value)) {
          this.creditCardIcon = {
            display: true
          }
        }

        if (DataType.LoanTagsEnum.COMPRESS_SIGNATURE_LINK.value === (tags & DataType.LoanTagsEnum.COMPRESS_SIGNATURE_LINK.value)) {
          this.compressIcon = {
            display: true
          }
        }
        if (this.tool.isNotEmpty(flags)) {
          if ((DataType.LoanFlagsEnum.FOX_EXPRESS.value & flags) === DataType.LoanFlagsEnum.FOX_EXPRESS.value) {
            this.foxExpressIcon = {
              display: true
            }
          }
        }
        if (DataType.LoanTagsEnum.SP_PO_WITHOUT_COLLECTION.value === (tags & DataType.LoanTagsEnum.SP_PO_WITHOUT_COLLECTION.value) || DataType.LoanTagsEnum.SP_CLOSE.value === (tags & DataType.LoanTagsEnum.SP_CLOSE.value)) {
          this.returningIcon = {
            style: 'done_all',
            color: 'color: green !important;',
            title: 'Paid Off',
            display: true
          }
        } else if (DataType.LoanTagsEnum.DP_PO_WITHOUT_COLLECTION.value === (tags & DataType.LoanTagsEnum.DP_PO_WITHOUT_COLLECTION.value) || DataType.LoanTagsEnum.DP_CLOSE.value === (tags & DataType.LoanTagsEnum.DP_CLOSE.value)) {
          this.returningIcon = {
            style: 'done_all',
            color: 'color: orange !important;',
            title: 'Paid Off',
            display: true
          }
        } else if (DataType.LoanTagsEnum.SP_PO_COLLECTION.value === (tags & DataType.LoanTagsEnum.SP_PO_COLLECTION.value) || DataType.LoanTagsEnum.SP_PO_COLLECTION_REJECT.value === (tags & DataType.LoanTagsEnum.SP_PO_COLLECTION_REJECT.value) || DataType.LoanTagsEnum.SP_ELSE_REJECT.value === (tags & DataType.LoanTagsEnum.SP_ELSE_REJECT.value)) {
          this.returningIcon = {
            style: 'sync_alt',
            color: 'color: green !important;',
            title: 'Loan Transfer',
            display: true
          }
        } else if (DataType.LoanTagsEnum.DP_GOOD_RATIO.value === (tags & DataType.LoanTagsEnum.DP_GOOD_RATIO.value) || DataType.LoanTagsEnum.DP_PO_COLLECTION.value === (tags & DataType.LoanTagsEnum.DP_PO_COLLECTION.value) || DataType.LoanTagsEnum.DP_ELSE.value === (tags & DataType.LoanTagsEnum.DP_ELSE.value)) {
          this.returningIcon = {
            style: 'sync_alt',
            color: 'color: orange !important;',
            title: 'Loan Transfer',
            display: true
          }
        } else if (DataType.LoanTagsEnum.SP_GOOD_REJECT.value === (tags & DataType.LoanTagsEnum.SP_GOOD_REJECT.value)) {
          this.returningIcon = {
            style: 'price_check',
            color: 'color: green !important;',
            title: 'Good D/C',
            display: true
          }
        } else if (DataType.LoanTagsEnum.DP_GOOD.value === (tags & DataType.LoanTagsEnum.DP_GOOD.value)) {
          this.returningIcon = {
            style: 'price_check',
            color: 'color: orange !important;',
            title: 'Good D/C',
            display: true
          }
        } else if (DataType.LoanTagsEnum.ROCKET_CREDIT.value === (tags & DataType.LoanTagsEnum.ROCKET_CREDIT.value)) {
          this.returningIcon = {
            style: 'flash_on',
            color: 'color: green !important;',
            title: 'Rocket Credit',
            display: true
          }
        }
      }
    },
    showReturningCustomerDialog (loanData) {
      const $this = this
      const lockReason = $this.store.getters.getLockReason

      if (lockReason === DataType.LockLoanReasonEnum.GENERATE_LOAN.value &&
        loanData.category === DataType.CategoryEnum.RETURNING_CUSTOMER.value &&
        loanData.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value) {
        $this.returningDialog.show = true
        $this.returningDialog.timer = setTimeout(function () {
          $this.returningDialog.showBtn = false
          clearTimeout($this.returningDialog.timer)
          $this.returningDialog.timer = null
        }, 4000)
      }
    },
    showFollowUpDialog () {
      const $this = this
      const request = {
        loanId: $this.loanId
      }
      const lockReason = $this.store.getters.getLockReason
      if (lockReason === DataType.LockLoanReasonEnum.GENERATE_LOAN.value &&
        $this.loan.loanStatus === DataType.LoanStatus.AGENT_REVIEW.value) {
        OriginationBusinessApi.followUpJudge(request, function (result) {
          if (tool.isNotEmpty(result)) {
            if (tool.isNotEmpty(result.followUpAt)) {
              $this.followUpDialog.followUpInfo = result.followUpAt
            }
            $this.followUpDialog.show = result.isShowFollowUp
          }
        })
      }
    }
  }
}
</script>

<style lang="css">
.loan-no {
  font-weight: 400;
  font-size: 30px !important;
  line-height: 1.2;
  float: left;
}

/*Do Not Remove*/
.loan-no-text {
  animation:change 1s linear 0s infinite;
}

@keyframes change {
  0% {
    color: #000410;
  }
  25% {
    color: #03a9f4;
  }
  50% {
    color: #009688;
  }
  75% {
    color: orange;
  }
  100% {
    color: red;
  }
}
/*Do Not Remove*/

.identifier-container {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  height: 43px;
}

.flag-container {
  height: 14px;
}

.flag-container .flag {
  margin: 0;
  height: 20px;
}

.action-button {
  height: 36px;
  width: 20px;
  margin: 0;
}

.data-form {
  font-size: 14px;
  padding-top: 8px;
}

.profile-summary .row,
.data-form .row {
  margin: auto !important;
}

.profile-summary .flex {
  padding: 0 !important;
}
.material-icons {
  font-size: 18px;
}
.data-form .flex {
  padding: 0 10px !important;
}
.snackbar {
  height: 100px!important;
  width: 480px!important;
}
.snackbar-title {
  font-size: 14px!important;
}
.snackbar-text {
  font-size: 10px
}
.snackbar-button {
  font-size: 8px!important;float: right
}
</style>
